import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Organization } from './organization'
import { organizationActions } from './organization.actions'
import * as fromOrganization from './organization.reducer'
import { OrganizationService } from './organization.service'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { switchMap, take, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class OrganizationEffects extends ResourceEffects<Organization> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private organizationService: OrganizationService
  ) {
    super(
      fromOrganization.FEATURE_NAME,
      organizationService,
      organizationActions,
      actions$
    )
  }
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(organizationActions.resetState())})
      ),
    { dispatch: false }
  )
}
